<script lang="ts" setup>
definePageMeta({
  validate: validateAndCacheEntity('region', fetchRegionBySlug),
  authType: 'public',
})

const slugId = computed(() => useSlugId().value._unsafeUnwrap())
const { data: region, suspense } = useRegionBySlug(slugId)
onServerPrefetch(async () => {
  await suspense()
})

useSeoMeta({
  title: computed(() => region.value?.name ?? ''),
})
</script>

<template>
  <div v-if="region">
    <AlRegionHeader :region="region" />

    <AlCmsPageSection
      v-for="section of region.cms_page_section"
      :key="section.id"
      :section="section"
    />

    <AlRegionPageShowcase />
  </div>
  <div v-else />
</template>
